import { createContext } from 'react';
import type { IDocumentTable } from '@models/Forms/IForms';

export const TableColumnSettingsUserContext = createContext<string | undefined>(undefined);

/** Нет контекста формы — выбор работает в памяти, но не перезаписывает настройки других форм. */
export const TableColumnSettingsContext = createContext<(table: IDocumentTable) => string | undefined>(() => undefined);
